import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "tipoSelect",
    "addOptionButton",
    "addConditionButton",
    "condicoesContainer",
    "opcoesContainer",
  ]

  connect() {
    if (this.hasTipoSelectTarget) this.toggleOpcao()
    this.onNestedAdd = this.onNestedAdd.bind(this)
    this.onNestedRemove = this.onNestedRemove.bind(this)
    document.addEventListener("nested-rondo:add", this.onNestedAdd)
    document.addEventListener("nested-rondo:remove", this.onNestedRemove)

    // 🧩 Initialize destino selects for editing existing campos
    this.initializeExistingDestinos()
  }

  disconnect() {
    document.removeEventListener("nested-rondo:add", this.onNestedAdd)
    document.removeEventListener("nested-rondo:remove", this.onNestedRemove)
  }


    toggleOpcao() {

    if (!this.hasTipoSelectTarget) return

    const tipo = this.tipoSelectTarget.value
    const shouldShowOpcoes = ["escolha_unica", "escolha_multipla"].includes(tipo)

    if(this.hasAddOptionButtonTarget) {
      this.addOptionButtonTarget.classList.toggle("d-none", !shouldShowOpcoes)
      if (!shouldShowOpcoes) this.removeAllOpcoes()
    }

    const shouldShowCondicoes = ["numero"].includes(tipo)

    if(this.hasAddConditionButtonTarget) {
      this.addConditionButtonTarget.classList.toggle("d-none", !shouldShowCondicoes)
      if (!shouldShowCondicoes) this.removeAllCondicoes()
    }
  }

  removeAllOpcoes() {
    if (!this.hasOpcoesContainerTarget) return
    const container = this.opcoesContainerTarget

    container.querySelectorAll(".opcao-field").forEach(opcao => {
      const removeBtn = opcao.querySelector('[data-association="remove"]')
      if (removeBtn) removeBtn.click()
      else opcao.remove()
    })
  }

  removeAllCondicoes() {
    if (!this.hasCondicoesContainerTarget) return
    const container = this.condicoesContainerTarget

    container.querySelectorAll(".condicao-field").forEach(condicao => {
      const removeBtn = condicao.querySelector('[data-association="remove"]')
      if (removeBtn) removeBtn.click()
      else condicao.remove()
    })
  }

  populateDestinoOnFocus(event) {
    const select = event.target
    const currentValue = select.value // previously selected destino_encoded

    const modalEl = select.closest('.modal')
    if (!modalEl) return console.warn("No modal found for destino select")

    const currentCampoEl = select.closest('.campo-field')
    const currentCampoId =
      currentCampoEl?.dataset.campoId ||
      currentCampoEl?.querySelector('input, select')?.name?.match(/\[(new_\d+|\d+)\]/)?.[1] ||
      null

    const currentFaseId = modalEl.dataset.faseId || modalEl.id || null

    // Build local campos AFTER current campo
    const localCampos = Array.from(modalEl.querySelectorAll('.campo-field'))
      .map(campoEl => {
        const textoInput = campoEl.querySelector('input[name*="[texto]"]')
        const nome = textoInput?.value?.trim() || "Campo sem nome"
        const id =
          campoEl.dataset.campoId ||
          campoEl.querySelector('input, select')?.name?.match(/\[(new_\d+|\d+)\]/)?.[1]
        return { id, nome, el: campoEl }
      })
      // Only include campos that are "after" current
      .filter(campo => {
        if (campo.id === currentCampoId) return false
        // Compare DOM position to only allow forward
        return currentCampoEl.compareDocumentPosition(campo.el) & Node.DOCUMENT_POSITION_FOLLOWING
      })

    // Get current fase's drawflowId
    const currentFaseData = _stagedFlow.fases[currentFaseId.replace("faseModal_node_", "")]
    const currentDrawflowId = currentFaseData?.drawflowId || 0
    // External fases AFTER current fase
    const externalFases = []
    if (typeof _stagedFlow !== "undefined" && _stagedFlow.fases) {
      for (const [nodeId, fase] of Object.entries(_stagedFlow.fases)) {
        // Only allow fases with higher drawflowId
        if (fase.node_id.replace("node_","") <= currentFaseId.replace("faseModal_node_", "")) continue
        externalFases.push({
          id: fase.node_id,
          nome: fase.nome
        })
      }
    }


    // Reset options
    select.innerHTML = ""

    // Actions optgroup
    const optAcoes = document.createElement("optgroup")
    optAcoes.label = "Ações"
    const acoes = [
      { value: null, nome: "Seguir fluxo" },
      { value: "status:aprovado", nome: "Aprovar e finalizar" },
      { value: "status:negado", nome: "Negar e finalizar" },
      { value: "status:finalizado", nome: "Finalizar com status finalizado" }
    ]
    acoes.forEach(item => {
      const option = document.createElement("option")
      option.value = item.value
      option.textContent = item.nome
      optAcoes.appendChild(option)
    })

    // Local campos optgroup
    const optLocal = document.createElement("optgroup")
    optLocal.label = "Campos"
    localCampos.forEach(item => {
      const option = document.createElement("option")
      option.value = "campo:" + item.id
      option.textContent = item.nome
      optLocal.appendChild(option)
    })

    // External fases optgroup
    const optExternal = document.createElement("optgroup")
    optExternal.label = "Fases"
    externalFases.forEach(item => {
      const option = document.createElement("option")
      option.value = "fase:" + item.id
      option.textContent = item.nome
      optExternal.appendChild(option)
    })

    select.appendChild(optAcoes)
    select.appendChild(optLocal)
    select.appendChild(optExternal)

    // Re-select previous value if it exists
    if (currentValue) {
      const matchingOption = Array.from(select.options).find(o => o.value === currentValue)
      if (matchingOption) {
        select.value = currentValue
      }
    }
  }



  onNestedAdd(event) {
    const added = event.target  // <- the new DOM element inserted by Rondo
    if (!added.dataset.nestedRondoFieldClassValue || added.dataset.nestedRondoFieldClassValue !== "opcao-field") {
      return
    }
    // Find its parent campo
    const campoWrapper = added.closest(".campo-field")
    if (!campoWrapper) return

    // Find the tipo select for that campo
    const tipoSelect = campoWrapper.querySelector('[name*="[tipo]"]')
    if (!tipoSelect) return

    // Initial toggle
    this.toggleDestinoId(added, tipoSelect.value)

    // Listen for changes to tipo to update dynamically
    tipoSelect.addEventListener("change", (e) => {
      this.toggleDestinoId(added, e.target.value)
    })
  }

  toggleDestinoId(opcaoEl, tipo) {
    // The destino container has data-fase-modal-target="destinoContainer"
    const destinoContainer = opcaoEl.querySelectorAll("[data-fase-modal-target='destinoContainer']").forEach(destinoField => {
      if (tipo == "escolha_unica") {
        destinoField.classList.remove("d-none")
      } else {
        destinoField.classList.add("d-none")
      }
    })
  }

  // 🧩 When something is removed, reset its references
  onNestedRemove(event) {
    const removed = event.target
    if (!removed) return

    // If a campo was removed, get its id
    if (removed.classList.contains("campo-field")) {
      // Try to extract campo ID from its input name
      const nameInput = removed.querySelector('input[name*="[texto]"]')
      const match = nameInput?.name?.match(/\[(new_[^\]]+|\d+)\]/)
      const removedCampoId = match ? match[1] : null
      const removedValue = `campo:${removedCampoId}`;

      console.log("Removed campo ID:", removedCampoId)

      if (!removedCampoId) return

      // Reset destino selects that reference this campo
      document.querySelectorAll('select[name*="[destino_encoded]"]').forEach(select => {
        if (select.value === removedValue) {
          this.resetToSeguirFluxo(select)
        }
      })

      // Clear _stagedFlow
      Object.values(_stagedFlow.fases).forEach(fase => {
      // Loop through campos
        if (!fase.campos) return;

        fase.campos.forEach(campo => {
          // Check opcoes
          if (campo.opcoes) {
            campo.opcoes.forEach(opcao => {
              if (opcao.destino_encoded === removedValue) {
                opcao.destino_encoded = "seguir_fluxo";
              }
            });
          }

          // Check condicoes
          if (campo.condicoes) {
            campo.condicoes.forEach(condicao => {
              if (condicao.destino_encoded === removedValue) {
                condicao.destino_encoded = "seguir_fluxo";
              }
            });
          }
        });
      });
    }
  }


  // 🧩 Utility to set destino to "Seguir fluxo"
  resetToSeguirFluxo(select) {
    const seguirOption =
      Array.from(select.options).find(opt => opt.value === "seguir_fluxo") ||
      (() => {
        const o = document.createElement("option")
        o.value = "seguir_fluxo"
        o.textContent = "Seguir fluxo"
        select.appendChild(o)
        return o
      })()

    select.value = "seguir_fluxo"
    select.dispatchEvent(new Event("change", { bubbles: true }))
  }

  initializeExistingDestinos() {
    // Find all destino selects that already exist on page load
    const selects = this.element.querySelectorAll('select[name*="[destino_encoded]"]')

    selects.forEach(select => {
      // Populate with options like in populateDestinoOnFocus
      this.populateDestinoOnFocus({ target: select })

      // Restore its saved value (if present in dataset or value attribute)
      const savedValue = select.dataset.savedValue || select.value
      if (savedValue) {
        // Try to find an option that matches
        const option = Array.from(select.options).find(opt => opt.value === savedValue)
        if (option) {
          select.value = savedValue
        } else {
          // If not found, add it manually
          const customOption = document.createElement("option")
          customOption.value = savedValue
          customOption.textContent = `${savedValue}`
          select.appendChild(customOption)
          select.value = savedValue
        }
      }

      // Ensure the destino field visibility matches tipo
      const campoEl = select.closest(".campo-field")
      const tipoSelect = campoEl?.querySelector('[name*="[tipo]"]')
      if (tipoSelect) {
        this.toggleDestinoId(campoEl, tipoSelect.value)
      }
    })
}

}
